import { AppBar } from "@commonlibs";
import styled, { css } from "styled-components";
import Header from "../../Header/Header";

export const AppBarHeaderRoot = styled(AppBar).attrs({ position: "fixed", elevation: 0 })(
    ({ theme }) => css`
        top: 0;
        left: 0;
        height: var(--appbar-height);
        max-height: var(--appbar-height);
        background: transparent;
        
        min-height: var(--appbar-height);
        .AppBarContent {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .Divider,
        .header {
            width: 100%;
            margin: 0 auto;
            ${theme.breakpoints.up("maxPageWidth")} {
                max-width: calc(${theme.breakpoints.values.maxPageWidth}px - 2px);
                border-left ${theme.border.sm};
                border-right ${theme.border.sm};
                border-color: ${theme.palette.overlays[800]["2"]};
            }
            @media screen and (orientation: landscape) and (max-width: ${theme.breakpoints.values.sm}px) {
                max-width: unset;
                border: none;
            }
        }
    `,
);

export const AppBarWrapper = styled.div.attrs({ position: "fixed", elevation: 0 })(
    ({ theme }) => css`
            width: 100%;
            margin: 0 auto;
            background: linear-gradient(180deg, #7575e5, #3b3b73);
            border-radius: 0px 0px 30px 30px;
            ${theme.breakpoints.up("maxPageWidth")} {
                max-width: calc(${theme.breakpoints.values.maxPageWidth}px - 2px);
                border-left ${theme.border.sm};
                border-right ${theme.border.sm};
                border-color: ${theme.palette.overlays[800]["2"]};
            }
            @media screen and (orientation: landscape) and (max-width: ${theme.breakpoints.values.sm}px) {
                max-width: unset;
                border: none;
            }
    `,
);

export const MainHeader = styled(Header)(
    () => css`
        flex: 1;
    `,
);
